import PdpLayout from "@/components/pdp/PdpLayout";
import { EYE_REPAIR_V31 } from "@/data/eyeRepairV31";

export default function PdpConceptV31() {
  return <PdpLayout data={EYE_REPAIR_V31} />;
}
